import React, {useEffect, useState} from 'react';
import {Alert, Box, Button, Container, Divider, Paper, TextField, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useAuth} from "../../context/AuthContext";
import {api} from "../../services/apiService";

export default function ForgotPassword() {
    const navigate = useNavigate();
    const {user} = useAuth();
    const [response, setResponse] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSendForgotPasswordMail = async (e) => {
        setLoading(true);
        setError('');
        setResponse('');
        e.preventDefault();

        if (!e.currentTarget.checkValidity()) {
            e.currentTarget.reportValidity();
            setLoading(false);
            return;
        }

        const formData = new FormData(e.currentTarget);
        const email = formData.get('email');

        api.post('auth/forgot_password', {email})
            .then((res) => {
                setResponse(res.data.message);
            })
            .catch((err) => {
                setError(err.response?.data?.message || 'Échec de l\'envoi de l\'email.');
            })

        setLoading(false);
    };

    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate])

    return (
        <Container maxWidth="sm"
                   sx={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Paper elevation={6} sx={{p: 4, width: '100%'}}>
                <Box sx={{textAlign: 'center', mb: 3}}>
                    <Typography variant="h4" component="h1" fontWeight={700}>
                        Mot de passe oublié ?
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Renseignez votre adresse mail pour recevoir un lien de réinitialisation.
                    </Typography>
                </Box>

                <Divider sx={{mb: 3}}/>

                {error && (
                    <Alert severity="error" sx={{mb: 2}}>
                        {error}
                    </Alert>
                )}

                {response && (
                    <Alert severity="success" sx={{mb: 2}}>
                        {response}
                    </Alert>
                )}

                <Box component="form" onSubmit={handleSendForgotPasswordMail}
                     sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
                    <TextField name="email" label="Adresse mail" variant="outlined" fullWidth required/>

                    <Button type="submit" variant="contained" size="large" sx={{mt: 1}} disabled={loading}>
                        Envoyer
                    </Button>
                    <Button variant="outlined" size="large" onClick={() => navigate('/login')} disabled={loading}>
                        Annuler
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}